export default __webpack_public_path__ + "static/media/hosting2.e20355d2.png";